<template>
  <div class="list-con">
    <a :href="toRowPage" class="list-header-img" :class="[isShowTopImageAnimation ? 'slide-out-up':'']"
      v-show="isShowTopImage"
    >
        <div class="list-header-img-m">
            <div class="list-header-img-close" @click.stop.prevent="closeEffectFn">
                <img src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/header-arrow.png">
                <span class="list-header-img-close-txt">
                    收起 <span id="list-header-img-time">{{timerSecond}}</span>s
                </span>
            </div>
        </div>
    </a>
    <!-- <img class="list-header-img" src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/header-1.jpg"> -->
    <div class="list-box">
      
      <!-- content -->
      <!-- 搜索框 -->
      <CruiseSearchInputRow
          :onKeywordConfirmHandler="onKeywordConfirmHandler"
          :topSearchs="topSearchs"
          :initKeyword="selectFilterCodes.keyword"
      />
      <!-- 筛选框 -->
      <CruiseSearchFilterRow v-if="page"
                          :cruiseFilters="cruiseFilters"
                          :initSelectFilterCodes="selectFilterCodes"
                          :months="months"
                          :shipCodes="shipCodes"
                          :departures="departures"
                          :destinations="destinations"
                          :tags="tags"
                          :tagFilters="tagFilters"
                          :filterConfirmHandler="filterConfirmHandler"
                          :onClearCruiseFilter="onClearCruiseFilter"
                          :festiveHoliday="festiveHoliday"
                          :tagPromoList="tagPromoList"
                          :tagThemeList="tagThemeList"
      />

      <div class="list-content">
        <div class="list-content-left">
          <!-- 排序筛选条件 -->
          <CruiseSearchOrderByRow
              :cruiseFilters="cruiseFilters"
              :initSelectFilterCodes="selectFilterCodes"
              :orderByConfirmHandler="orderByConfirmHandler"
              :showAgencyHandler="showAgencyHandler"
              v-on:showCruisePricePopup="showCruisePricePopup"
              @showSoldOut="showSoldOutHandler"
          />
            
          <!-- 列表 -->
          <div class="cruise--list" ref="cruiseList">
            <CruiseSearchItem
                v-for="(cruise, i) in cruiseLists" :key="i"
                :cruise="cruise"
                :showLoginPopup="showLoginPopup"
                v-on:onMoreSailDateClick="onMoreSailDateClick"
                :showRow="false"
            />
          </div>

          <!-- 说明 -->

          <!-- 分页 -->
          <Pagination
              :config="pageConfig"
              v-on:changeCurrentPage="onPaginationChange"
          />

          <!-- 没有航线提示 -->
          <div class="no-cruise-tips" v-if="storedCruiseCount==0">
            航线计划中，敬请期待
<!--            尚无筛选结果，请<a href="/Rccl.Cruise/CruiseSearch/Search">重新选择</a>-->
          </div>


        </div>

        <!-- 右侧内容 -->
        <CruiseSearchRightRow/>

      </div>
    </div>

    <MoreSailDatePopup
        :isShow="isShowMoreSailDatePopup"
        :cruise="targetCruise"
        :moreSailDatePopupClose="moreSailDatePopupClose"
        v-on:onCruiseAddWishList="onCruiseAddWishList"
        v-on:onCruiseDeleteWishList="onCruiseDeleteWishList"
        :showLoginPopup="showLoginPopup"
    />

    <CruisePricePopupRow
        :isShow="isShowCruisePriceInfoPopup"
        v-on:onModalClose="closeCruisePricePopup"
    />


    <LoginModal
        v-if="isShowLoginPopup"
        :onLoginSuccessHandler="onLoginSuccessHandler"
        :isShow="isShowLoginPopup"/>

    <EmergencyMessageAlert/>

    <!-- <div class="wn-baby-left wn-baby-image" v-if="showPromo===0" id="wnBabyLeft"
    :class="{ hover: isShowPromoEffect}" @mouseover="showEffect" @mouseleave="closeEffect" @click="goPromo">
      <img src="https://resource.rcclchina.com.cn/homePage/promotion/4.gif"/>
    </div>
    <div class="wn-baby-right wn-baby-image" v-else-if="showPromo===1" id="wnBabyRight"
    :class="{ hover: isShowPromoEffect}" @mouseover="showEffect" @mouseleave="closeEffect" @click="goPromo">
      <img src="https://resource.rcclchina.com.cn/homePage/promotion/3.gif"/>
    </div> -->

  </div>
</template>

<script>
import Cookies from "js-cookie";
import api from '@/api'
import _ from 'lodash'
import {getRandomInt} from '@/utilities/tools'
import { reportUserBrowsingRecord } from '@/utilities/common'
import { setInterval } from "core-js";
const promoCountDown = 8 * 1000;
const randomPromoOff = 1 * 1000;
const randomPromoShow = 6 * 1000 + randomPromoOff;

const CruiseSearchInputRow = () => import('@/components/Cruise/CruiseSearch/CruiseSearchInputRow.vue')
const CruiseSearchFilterRow = () => import('@/components/Cruise/CruiseSearch/CruiseSearchFilterRow.vue')
const CruiseSearchOrderByRow = () => import('@/components/Cruise/CruiseSearch/CruiseSearchOrderByRow.vue')
const CruiseSearchItem = () => import('@/components/Cruise/CruiseSearch/CruiseSearchItem.vue')
const CruiseSearchRightRow = () => import('@/components/Cruise/CruiseSearch/CruiseSearchRightRow.vue')
const MoreSailDatePopup = () => import('@/components/Cruise/MoreSailDatePopup.vue')
const CruisePricePopupRow = () => import('@/components/Cruise/CruiseDetail/CruisePricePopup.vue')
const Pagination = () => import('@/components/Common/Pagination.vue')
const LoginModal = () => import('@/components/User/LoginModal.vue')
const EmergencyMessageAlert = () => import('@/components/Common/EmergencyMessageAlert')
export default {
  name: "CruiseSearchRow",
  components: {
    CruiseSearchInputRow,
    CruiseSearchFilterRow,
    CruiseSearchOrderByRow,
    CruiseSearchItem,
    CruiseSearchRightRow,
    Pagination,
    MoreSailDatePopup,
    CruisePricePopupRow,
    LoginModal,
    EmergencyMessageAlert
  },
  asyncData({store}) {
    return new Promise((resolve, reject) => {
      return api.cruise.getCruiseSearchPage(true)
          .then(({success, data, errMsg}) => {
            if (!success) console.error(errMsg)
            store.commit('SET_CRUISE_SEARCH_PAGE_ROW', {data})
            if (data.seoViewModel) {
              store.commit('SET_META', data.seoViewModel)
            }
            resolve();
          })
          .catch((e) => {
            reject(e)
          })
    })
  },
  data() {
    return {
      imgUrl: process.env.VUE_APP_IMG_URL,
      isFirstLoading: true,
      selectFilterCodes: {
        "departures": [],
        "destinations": [],
        "sailDates": [],
        "sailDays": [],
        "shipCodes": [],
        "tags": [],
        "keywords": [],
        "orderBysailDate": 0,
        "orderByPrice": 0,
        "orderBySailDays": 0,
        "orderByAmountPerNight": 0,
        "orderByPopular": 0,
        "isAgency": false,
        includeSoldOut: false,//是否是售罄
        includeAgency: false,// 是否是包船
        tripMode: false,// 只看跟团游
      },
      queryString: {},
      initQueryString: '',
      offset: 0,
      limit: 10,
      cruiseLists: [],
      isLoadingCruise: false,
      isShowCruisePriceInfoPopup: false,
      isShowPopup: false,
      isShowLoginPopup: false,
      loginCallback: null,
      targetCruise: {
        sailDate: '',
        cruiseName: ''
      },
      isShowMoreSailDatePopup: false,
      showPromo: -1,
      checkPromoTimeout: null,
      isShowPromoEffect: false,
      promoEffectInterval: null,
			isPromoHover: false,
      baseInfo:{},
      userToken:this.$store.state.userToken,
      isShowTopImage:false,
      isShowTopImageAnimation:false,
      timerTopImage:null,
      timerSecond:6,
      toRowPage: process.env.VUE_APP_ROW_CAMPAIGN_URL+'/campaign/ROWDestination/Cruise/CruisePortIndex',
      // 筛选上报相关：标记当前搜索是否需要上报筛选行为
      shouldReportSearch: false
    }
  },
  mounted() {
    // 获取 cookies 如果有参数 不显示 顶部图片
    const cookie = Cookies.get("cruisePortBanner");
    if(cookie){
      this.isShowTopImage = false
    }else{
      this.isShowTopImage = true
      this.timerTopImage = setInterval(()=>{
        this.timerSecond--
        if(this.timerSecond <=0){
          this.closeEffectFn()
        }
      },1000)
    }
  },
  activated() {
    // 当init query string不同时，说明url参数有变化，需要重新刷新页面
    if (this.initQueryString != JSON.stringify(this.$route.query) && !this.isFirstLoading) {
      return this.initPage()
    }
    // if (this.showPromo < 0) {
    //   this.showPromoTimeout();
    // }
  },
  deactivated () {
    this.showPromo = -1;
    if (this.checkPromoTimeout) {
			clearTimeout(this.checkPromoTimeout);
		}
    if (this.promoEffectInterval) {
      clearInterval(this.promoEffectInterval);
    }
  },
  methods: {
    // 收起
    closeEffectFn(){
      console.log(this.timerTopImage,'closeEffect')
      this.isShowTopImageAnimation = true
      setTimeout(()=>{
        this.isShowTopImage = false
      },1400)
      if(this.timerTopImage){
        clearInterval(this.timerTopImage)
        this.timerTopImage = null
        Cookies.set('cruisePortBanner', '1', { expires: 1, path: '/' });
      }
    },
    initPage() {
      // 根据query参数设定cruise filter
      const query = this.$route.query
      let filterRequests = []
      let filters = this.initFilters()

      if (query.sailDates) {
        query.sailDates.split(',').forEach((item) => {
          filterRequests.push({key: 'sailDates', values: [{"code": item}]})
          filters.sailDates.push({"code": item, "name": item})
        })
      }
      if (query.destinationCodes) {
        query.destinationCodes.split(',').forEach((item) => {
          // 解决例如冲绳那样会有多个code的问题
          const filter = this.cruiseFilters.find(r => r.filterCode && r.filterCode.indexOf(item) >= 0)
          if (filter && !filters.destinations.some(r => r.code == filter.filterCode)) {
            filterRequests.push({key: 'destinations', values: [{"code": filter.filterCode}]})
            filters.destinations.push({"code": filter.filterCode})
          }
        })
      }
      if (query.departureCodes) {
        query.departureCodes.split(',').forEach((item) => {
          filterRequests.push({key: 'departures', values: [{"code": item}]})
          let data = {"code": item}

          const cruieFilter = this.cruiseFilters.filter(r => r.filterCode == item)
          if (cruieFilter && cruieFilter.length > 0) {
            data.name = cruieFilter[0].title
          }
          filters.departures.push(data)
        })
      }
      if (query.shipCodes) {
        query.shipCodes.split(',').forEach((item) => {
          filterRequests.push({key: 'shipCodes', values: [{"code": item}]})
          filters.shipCodes.push({"code": item})
        })
      }
      if (query.sailDays) {
        query.sailDays.split(',').forEach((item) => {
          const sailDay = parseInt(item)
          if (!isNaN(sailDay)) {
            filterRequests.push({key: 'sailDays', values: [{"code": sailDay}]})
            filters.sailDays.push({"code": sailDay})
          }
        })
      }
      if (query.tags) {
        query.tags.split(',').forEach((item) => {
          item = decodeURIComponent(item)
          filterRequests.push({key: 'tags', values: [{"code": item}]})
          filters.tags.push({"code": item})
        })
      }
      if (query.keyword && query.keyword.length > 0) {
        filters.keyword = query.keyword
      }
      // 热门标签-与上方相关
      // if (query.keywords && query.keywords.length > 0) {
      //   query.keywords.split(',').forEach((item) => {
      //     item = decodeURIComponent(item)
      //     filterRequests.push({key: 'keywords', values: [{"code": item}]})
      //     filters.keywords.push({"code": item})
      //   })
      // }
      if (query.orderBysailDate && query.orderBysailDate > 0) {
        filters.orderBysailDate = query.orderBysailDate
      }
      if (query.orderByPrice && query.orderByPrice > 0) {
        filters.orderByPrice = query.orderByPrice
        filters.orderBysailDate = 0
      }
      if (query.orderByPopular && query.orderByPopular > 0) {
        filters.orderByPopular = query.orderByPopular
        filters.orderByPopular = 0
      }
      if (query.orderByAmountPerNight && query.orderByAmountPerNight > 0) {
        filters.orderByAmountPerNight = query.orderByAmountPerNight
        filters.orderByAmountPerNight = 0
      }
      this.cruiseLists = []
      this.initQueryString = JSON.stringify(query)
      this.baseInfo = this.$store.state.user.userInfo;
      // URL 带筛选条件时，标记需要上报
      if (filterRequests.length > 0 || (query.keyword && query.keyword.length > 0)) {
        this.shouldReportSearch = true
      }
      return this.setInitCruiseFilter(filters, filterRequests)

    },
    setInitCruiseFilter(filters, filterRequests) {
      this.$store.dispatch('INIT_CRUISE_FILTER_LIST_ROW', {cruiseType: "hp", data: filterRequests})
      this.selectFilterCodes = filters
      this.offset = 0

      return this.cruiseSearch()
    },
    cruiseSearch() {
      const token = this.$store.state.user.userToken
      let request = _.cloneDeep(this.selectFilterCodes)
      request.username = token
      request.offset = this.offset
      let keywordsItme = ''
      this.selectFilterCodes.keywords && this.selectFilterCodes.keywords.forEach((item,idx)=>{
        if(item.code){
          if(idx>0){
            keywordsItme += ","+item.code
          }else{
            keywordsItme += item.code
          }
        }
      })
      request.keywords = keywordsItme
      this.$loading.show()
      this.isLoadingCruise = true
      return this.$store.dispatch("CRUISE_SEARCH_ROW", {data: request})
    },
    filterConfirmHandler(filterCodes) {
      const orderBySailDate = filterCodes.filter(r => r.key == "orderBysailDate")
      const orderByPrice = filterCodes.filter(r => r.key == "orderByPrice")
      const orderByPopular = filterCodes.filter(r => r.key == "orderByPopular")
      const orderByAmountPerNight = filterCodes.filter(r => r.key == "orderByAmountPerNight")
      this.selectFilterCodes = {
        ...this.selectFilterCodes,
        "departures": filterCodes.filter(r => r.key == "departures"),
        "destinations": filterCodes.filter(r => r.key == "destinations"),
        "sailDates": filterCodes.filter(r => r.key == "sailDates"),
        "sailDays": filterCodes.filter(r => r.key == "sailDays"),
        "shipCodes": filterCodes.filter(r => r.key == "shipCodes"),
        "tags": filterCodes.filter(r => r.key == "tags"),
        "keyword": this.selectFilterCodes.keyword,
        "keywords": filterCodes.filter(r => r.key == "keywords"),
        "orderBysailDate": orderBySailDate && orderBySailDate.length > 0 ? orderBySailDate[0].code : 0,
        "orderByPrice": orderByPrice && orderByPrice.length > 0 ? orderByPrice[0].code : 0,
        "orderByPopular": orderByPopular && orderByPopular.length > 0 ? orderByPopular[0].code : 0,
        "orderByAmountPerNight": orderByAmountPerNight && orderByAmountPerNight.length > 0 ? orderByAmountPerNight[0].code : 0,
      }
      this.shouldReportSearch = true
      this.offset = 0;
      this.cruiseLists = []
      this.cruiseSearch()
      this.replaceUrl()
    },
    orderByConfirmHandler(seqFilter) {
      this.selectFilterCodes.orderBysailDate = seqFilter.orderBysailDate
      this.selectFilterCodes.orderByPrice = seqFilter.orderByPrice
      this.selectFilterCodes.orderByPopular = seqFilter.orderByPopular
      this.selectFilterCodes.orderByAmountPerNight = seqFilter.orderByAmountPerNight
      this.shouldReportSearch = false // 排序不上报
      this.offset = 0;
      this.cruiseLists = []
      this.cruiseSearch()
      this.replaceUrl()
    },
    showAgencyHandler(isShow) {
      // this.selectFilterCodes.includeAgency = isShow
      // this.selectFilterCodes.includeSoldOut = isShow
      this.selectFilterCodes.includeAgency = isShow
      this.shouldReportSearch = false // 包船不上报
      this.offset = 0;
      this.cruiseLists = []
      this.cruiseSearch()
      this.replaceUrl()
    },
    showSoldOutHandler(isShow) {
      // this.selectFilterCodes.tripMode = isShow
      this.selectFilterCodes.includeSoldOut = isShow
      this.shouldReportSearch = false // 售罄不上报
      this.offset = 0;
      this.cruiseLists = []
      this.cruiseSearch()
      this.replaceUrl()
    },
    onKeywordConfirmHandler(keyword) {
      this.selectFilterCodes.keyword = keyword
      this.shouldReportSearch = true
      this.offset = 0;
      this.cruiseLists = []
      this.cruiseSearch()
      this.replaceUrl()
    },
    // 热门标签-与上方相关
    // onKeywordsConfirmHandler(keywords) {
    //   this.selectFilterCodes.keywords = keywords
    //   this.offset = 0;
    //   this.cruiseLists = []
    //   this.cruiseSearch()
    //   this.replaceUrl()
    // },
    onPaginationChange(page) {
      const offset = (page - 1) * this.limit
      if (offset != this.offset) {
        this.offset = offset
        this.cruiseLists = []
        this.cruiseSearch()
      }
    },
    onClearCruiseFilter() {
      this.offset = 0;
      this.cruiseLists = []
      const filters = this.initFilters()
      this.setInitCruiseFilter(filters, [])
      this.replaceUrl()
    },
    // 从 selectFilterCodes 收集当前所有筛选条件的name值，用于上报Parameters
    collectFilterNamesFromState() {
      const names = []
      const { departures, destinations, sailDates, sailDays, shipCodes, tags, keyword } = this.selectFilterCodes
      // 出发港口
      departures.forEach(item => names.push(this.getFilterName(item)))
      // 目的地
      destinations.forEach(item => names.push(this.getFilterName(item)))
      // 出发月份
      sailDates.forEach(item => names.push(item.name || item.code))
      // 航行天数
      sailDays.forEach(item => names.push(item.name || item.code))
      // 游轮名称
      shipCodes.forEach(item => names.push(this.getFilterName(item)))
      // 标签
      tags.forEach(item => names.push(item.name || item.code))
      // 关键字
      if (keyword) names.push(keyword)
      return names
    },
    // 根据code从cruiseFilters查找对应的name(title)
    getFilterName(item) {
      if (item.name) return item.name
      const match = this.cruiseFilters.find(f => f.filterCode === item.code)
      return match ? match.title : item.code
    },
    replaceUrl() {
      // 根据搜索条件修改url参数
      let url = '/Rccl.Cruise/CruiseSearch/SearchRow'
      console.log('selectFilterCodes',this.selectFilterCodes)
      let query = ''
      if (this.selectFilterCodes.departures.length > 0) {
        query += '&departureCodes=' + this.selectFilterCodes.departures.map(r => r.code).join(',')
      }
      if (this.selectFilterCodes.shipCodes.length > 0) {
        query += '&shipCodes=' + this.selectFilterCodes.shipCodes.map(r => r.code).join(',')
      }
      if (this.selectFilterCodes.sailDates.length > 0) {
        query += '&sailDates=' + this.selectFilterCodes.sailDates.map(r => r.code).join(',')
      }
      if (this.selectFilterCodes.sailDays.length > 0) {
        query += '&sailDays=' + this.selectFilterCodes.sailDays.map(r => r.code).join(',')
      }
      if (this.selectFilterCodes.destinations.length > 0) {
        query += '&destinationCodes=' + this.selectFilterCodes.destinations.map(r => r.code).join(',')
      }
      if (this.selectFilterCodes.tags.length > 0) {
        query += '&tags=' + this.selectFilterCodes.tags.map(r => r.code).join(',')
      }
      if (this.selectFilterCodes.orderBysailDate > 0) {
        query += '&orderBysailDate=' + this.selectFilterCodes.orderBysailDate
      }
      if (this.selectFilterCodes.orderByPrice > 0) {
        query += '&orderByPrice=' + this.selectFilterCodes.orderByPrice
      }
      if (this.selectFilterCodes.orderByPopular > 0) {
        query += '&orderByPopular=' + this.selectFilterCodes.orderByPopular
      }
      if (this.selectFilterCodes.orderByAmountPerNight > 0) {
        query += '&orderByAmountPerNight=' + this.selectFilterCodes.orderByAmountPerNight
      }
      if (this.selectFilterCodes.keyword && this.selectFilterCodes.keyword.length > 0) {
        query += '&keyword=' + this.selectFilterCodes.keyword
      }
      // 热门标签-与上方相关
      // if (this.selectFilterCodes.keywords && this.selectFilterCodes.keywords.length > 0) {
      //   query += '&keywords=' + this.selectFilterCodes.keywords.map(r => r.code).join(',')
      // }
      if (query.length > 0) {
        url += '?' + query.substring(1)
      }
      url = encodeURI(url)
      history.replaceState({}, "new page", url);
    },
    initFilters() {
      return {
        "departures": [],
        "destinations": [],
        "sailDates": [],
        "sailDays": [],
        "shipCodes": [],
        "tags": [],
        "keywords": [],
        "orderBysailDate": 0,
        "orderByPrice": 0,
        "orderByPopular": 0,
        "orderByAmountPerNight": 0,
        "isAgency": false,
        includeSoldOut: false,//是否是售罄
        includeAgency: false,// 是否是包船
        tripMode: false,// 只看跟团游
      }
    },
    onMoreSailDateClick(cruise) {
      this.targetCruise = cruise
      this.isShowMoreSailDatePopup = true
    },
    moreSailDatePopupClose() {
      this.targetCruise = {}
      this.isShowMoreSailDatePopup = false
    },
    onCruiseAddWishList(cruiseId) {
      let cruise = this.cruiseLists.find(r => r.cruiseId == cruiseId)
      if (cruise) {
        cruise.inWish = true
        cruise.collections++
      }
    },
    onCruiseDeleteWishList(cruiseId) {
      let cruise = this.cruiseLists.find(r => r.cruiseId == cruiseId)
      if (cruise) {
        cruise.inWish = false
        if (cruise.collections > 0) {
          cruise.collections--
        }
      }
    },
    showCruisePricePopup() {
      this.isShowCruisePriceInfoPopup = true
    },
    closeCruisePricePopup() {
      this.isShowCruisePriceInfoPopup = false
    },
    showLoginPopup(callback) {
      this.isShowLoginPopup = true
      this.loginCallback = callback
    },
    onLoginSuccessHandler() {
      this.isShowLoginPopup = false
      if (this.loginCallback) {
        this.loginCallback()
        this.loginCallback = null
      }
    },
    showPromoTimeout () {
			if (this.checkPromoTimeout) {
				clearTimeout(this.checkPromoTimeout);
			}
			this.checkPromoTimeout = setTimeout(()=> {
				if (!this.userInfo || this.userInfo.userIdentity !== 1) {
					this.showPromoPopup();
				}
			}, promoCountDown)
		},
		showPromoPopup () {
			let random = Math.round(Math.random(100));
			this.showPromo = random % 2;
      this.showPromo = 0;
      if (this.showPromo === 0) {
        // 左边，位置出现在 10% ~ 70%
        let top = getRandomInt(10, 70);
				this.$nextTick(()=> {
					document.getElementById('wnBabyLeft').style.top = top + '%';
          this.showPromoEffect()
				})
      } else {
        // 右边 7% 或者 70%
				let top = 7;
				let now = new Date().getTime();
				if (now % 2 === 0) {
					top = 70;
				}
				this.$nextTick(()=> {
					document.getElementById('wnBabyRight').style.top = top + '%';
          this.showPromoEffect()
				})
      }
		},
    showPromoEffect () {

      if (this.promoEffectInterval) {
        clearInterval(this.promoEffectInterval)
      }
      this.promoEffectInterval = setInterval(()=> {
        this.isShowPromoEffect = true;
				setTimeout(()=> {
					if (!this.isPromoHover) {
						this.isShowPromoEffect = false;
					}
				}, randomPromoOff)
      }, randomPromoShow);
    },
		showEffect () {
			this.isPromoHover = true;
			this.isShowPromoEffect = true;
			if (this.checkPromoTimeout) {
				clearTimeout(this.checkPromoTimeout);
			}
			if (this.promoEffectInterval) {
				clearInterval(this.promoEffectInterval)
			}
		},
		closeEffect () {
			this.isPromoHover = false;
			this.isShowPromoEffect = false;
			this.showPromoEffect();
		},
		goPromo() {
      window.open("https://www.rcclchina.com.cn/privilege/qibao")
    },
    
  },
  computed: {
    userInfo () {
			return this.$store.state.user.userInfo
		},
    page() {
      return this.$store.state.cruiseRow.cruiseSearchPage
    },
    cruiseFilters() {
      return this.$store.state.cruiseRow.cruiseSearchPage.cruiseFilters
    },
    months() {
      return this.$store.state.cruiseRow.cruiseSearchPage.months
    },
    tags() {
      let tags = this.$store.state.cruiseRow.cruiseSearchPage.tags
      if (tags.length > 15) {
        tags = tags.slice(0, 15)
      }
      return tags
    },
    
    departures() {
      return this.cruiseFilters.filter(i => i.category == "DEPARTURE" && i.active)
    },
    destinations() {
      return this.cruiseFilters.filter(i => i.category == "DESTINATION" && i.active)
    },
    topSearchs() {
      return this.$store.state.cruise.cruiseSearchPage.topSearch
    },
    // 热门标签-与上方相关
    // tagTopShowList() {
    //   console.log('this.$store.state.cruise.cruiseSearchPage', this.$store.state.cruise.cruiseSearchPage)
    //   return this.$store.state.cruise.cruiseSearchPage.tagTopShowList
    // },
    shipCodes() {
      return this.cruiseFilters.filter(i => i.category == "SHIPS" && i.active)
    },
    tagFilters() {
      return this.cruiseFilters.filter(i => i.category == "TAG" && i.active)
    },
    storedCruiseLists() {
      return this.$store.state.cruiseRow.cruiseLists.items
    },
    storedCruiseCount() {
      return this.$store.state.cruiseRow.cruiseLists.count
    },
    festiveHoliday(){
      return this.$store.state.cruiseRow.cruiseSearchPage.tagHolidayList
    },
    tagPromoList(){
      return this.$store.state.cruiseRow.cruiseSearchPage.tagPromoList
    },
    tagThemeList(){
      return this.$store.state.cruiseRow.cruiseSearchPage.tagThemeList
    },
    pageConfig() {
      const currentPage = parseInt((this.offset) / this.limit) + 1;
      const allPage = parseInt((this.storedCruiseCount - 1) / this.limit) + 1;
      return {
        pageSize: this.limit,     //一页的数据条数
        pageNo: currentPage,        //当前页的索引
        total: this.storedCruiseCount,         //总的数据条数
        pageTotal: allPage      //总的页数
      }
    },
    isOverseaUser () {
      if (!this.baseInfo || !this.baseInfo.callingCode) {
        return false;
      }
      return this.baseInfo != null && this.baseInfo.callingCode != "86" && this.baseInfo.callingCode != '+86';
    },
    
  },
  watch: {
    cruiseFilters() {
      this.initPage()
    },
    storedCruiseLists(newOne) {
      newOne.forEach((cruise) => {
        if (!this.cruiseLists.some(r => r.sailDate == cruise.sailDate && r.shipCode == cruise.shipCode && r.supportDescription == cruise.supportDescription)) {
          this.cruiseLists.push(cruise)

          

        }
      })
      this.isLoadingCruise = false
      this.$loading.hide()
      // 筛选成功后上报浏览记录（排除排序、售罄、包船）
      if (this.shouldReportSearch) {
        const names = this.collectFilterNamesFromState()
        reportUserBrowsingRecord({
          ProductType: 3,
          ProductId: '',
          SceneType: 2,
          Parameters: names
        })
        this.shouldReportSearch = false
      }
      if (this.isFirstLoading) {
        this.isFirstLoading = false
      } else {
        const cruiseList = this.$refs.cruiseList
        if (cruiseList) {
          const top = cruiseList.offsetTop - 100
          window.scroll({
            top: top,
            behavior: 'smooth'
          })
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.list-con {
  width: 100%;
  background-color: #f0f0f0;

  .list-box {
    width: 1200px;
    margin: 0 auto;

  }
}

.list-content {
  overflow: hidden;

  .list-content-left {
    float: left;
    min-width: 922px;
  }

  .no-cruise-tips {
    text-align: center;
    font-size: 15px;
    margin-top: 30px;
  }
}

.wn-baby-image {
	position: fixed;
	width: 150px;
	z-index: 1112;
	cursor: pointer;
	img {
		width: 100%;
	}
}
.wn-baby-left {
	left: -50px;
	top: 50%;
	transition: left 0.2s;
	&.hover {
		left: -30px;
	}
}

.wn-baby-right {
	right: -64px;
	top: 10%;
	transition: right 0.2s;
	&.hover {
		right: -35px;
	}
}
.joinMemberBanner{
  width: 100%;
  height: 81px;
  margin-bottom: 12px;
  & img{
    width: 100%;
    height: 100%;
  }
}


.list-header-img {
  display: none;
    position: relative;
    width: 100%;
    display: block;
    min-width: 1200px;
    height: 206px;
    overflow: hidden;
    background: url('https://resource.rcclchina.com.cn/tui2/cruise/row-CruiseBanner.jpg') no-repeat top center;
}
.list-header-img img {
    width: 100%;
}
.list-header-img-m {
    position: absolute;
    left: 50%;
    top: 0;
    -webkit-transform: translateX(-50%);
       -moz-transform: translateX(-50%);
        -ms-transform: translateX(-50%);
         -o-transform: translateX(-50%);
            transform: translateX(-50%);
    width: 1200px;
    height: 100%;
    cursor: pointer;
}
.list-header-img-close {
    position: absolute;
    right: 0;
    top: 12px;
    font-size: 0;
}
.list-header-img-close img {
    display: inline-block;
    width: 14px;
    margin-right: 5px;
}
.list-header-img-close-txt {
    font-size: 14px;
    line-height: 1;
    color: #fff;
    vertical-align: middle;
}

.animated-fadeIn{
  display: block;
   animation-name:fadeIn; /*fadeInLeft为要使用的动画效果名，在这里不需要加animate前缀*/
   animation-duration: 2s; /*这里设定完成该动画的时间*/
}

.animated-slideUp{
  //  height: 0;
  //  overflow: hidden;
  //  display: none;
   animation-name:fadeOut; /*fadeInLeft为要使用的动画效果名，在这里不需要加animate前缀*/
   animation-duration: 2s; /*这里设定完成该动画的时间*/
}

@keyframes fadeInOutAni {
  0% { height: 206px; }
  100% { height: 0; }
}


.slide-out-up {
  animation-name: fadeInOutAni;
  animation-duration: 1.5s; /* 持续时间 */

}


</style>
